import clsx from "clsx";
import { ReactNode } from "react";
import RecurringTransactionCard from "./RecurringTransactionCard";
import ReceivedTransactionCard from "./ReceivedTransactionCard";
import PendingTransactionCard from "./PendingTransactionCard";
import ReceivedContactInviteCard from "./ReceivedContactInviteCard";

interface ICards {
  children: ReactNode;
  columns?: number;
}

type TCards = {
  RecurringTransaction: typeof RecurringTransactionCard;
  ReceivedTransaction: typeof ReceivedTransactionCard;
  PendingTransaction: typeof PendingTransactionCard;
  ContactInvite: typeof ReceivedContactInviteCard;
};

const Cards: React.FC<ICards> & TCards = ({ children, columns = 1 }) => {
  return (
    <div
      className={clsx([
        "grid",
        "grid-cols-1",
        `md:grid-cols-${columns}`,
        "2xl:grid-cols-3",
        "gap-4",
      ])}
    >
      {children}
    </div>
  );
};

Cards.RecurringTransaction = RecurringTransactionCard;
Cards.ReceivedTransaction = ReceivedTransactionCard;
Cards.PendingTransaction = PendingTransactionCard;
Cards.ContactInvite = ReceivedContactInviteCard;

export default Cards;
